import { app } from "../../main";

export const BasketService = {
  hasProduct(productId, contractId) {
    let products = this.getProducts();
    return products.some(
      value =>
        (value.contractId === contractId && value.productId === productId) ||
        (!contractId && value.productId === productId)
    );
  },
  addProduct(
    productId,
    productName,
    contractId,
    channelId,
    credentials,
    productType,
    vonq_price,
    daysToProcess,
    logo,
    customerId
  ) {
    let products = this.getProducts();

    const canAddToBasket =
      !customerId ||
      products
        .filter(p => p.customerId)
        .find(p => p.customerId !== customerId) === undefined;

    if (canAddToBasket) {
      products.push({
        productId: productId,
        productName: productName,
        contractId: contractId,
        channelId: channelId,
        credentials: credentials,
        productType: productType,
        vonq_price: vonq_price,
        daysToProcess: daysToProcess,
        logo: logo,
        customerId
      });
      localStorage.setItem("products", JSON.stringify(products));
    } else {
      app.$bvToast.toast(
        "You can’t add contracts to a campaign from different groups",
        {
          variant: "danger",
          solid: true
        }
      );
    }
  },

  removeProduct(productId, contractId) {
    let products = this.getProducts();
    if (!productId) {
      return;
    }
    products = products.filter(
      value =>
        (contractId && value.contractId !== contractId) ||
        value.productId !== productId
    );
    localStorage.setItem("products", JSON.stringify(products));
  },
  updateDisplayOptions(displayOptions) {
    localStorage.setItem("displayOptions", JSON.stringify(displayOptions));
  },
  getDisplayOptions() {
    if (localStorage.getItem("displayOptions")) {
      return JSON.parse(localStorage.getItem("displayOptions"));
    } else {
      return { currency: "EUR" };
    }
  },
  getItemsCount() {
    return this.getProducts().length;
  },
  getProducts() {
    if (localStorage.getItem("products")) {
      return JSON.parse(localStorage.getItem("products"));
    } else {
      return [];
    }
  },
  clearBasket() {
    localStorage.removeItem("products");
  }
};
